import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getEquipmentAvailableColumns } from './api';

export const path = '/ppr/equipment/list';

const PageEquipments: React.FC = (props) => {
  const Equipments = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getEquipmentAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Equipments {...props} />;
};

export default PageEquipments;
